import styled from "@emotion/styled";

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 35vw;
`

export default Form;